<template>
  <!-- 课程画像 -->
  <div class="page">
    <div :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程类型分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'coursesChart'" :datas='courses.dataList' :colorName='1' :innerText="'数量'"></circularChart>
            </div>
          </div>
        </el-col>
        <!-- <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程性质分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'natureDistributionChart'" :datas='natureDistribution.dataList' :colorName='1' :innerText="'数量'"></circularChart>
            </div>
          </div>
        </el-col> -->
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程引用资源数排名（前10名）</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'resourcesCitedChart'" :datas='resourcesCited.dataList' :transverseData='resourcesCited.transverseData' :colorList='resourcesCited.colorList' :gridY="'8%'" :gridHeight="'88%'"></tcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程使用率</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart :datas='courseUtilization.dataList' :colorList='courseUtilization.colorList'></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程访问时间段分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'timeDistributionChart'" :datas='timeDistribution.dataList' :transverseData='timeDistribution.transverseData' :colorList='timeDistribution.colorList' :legendList='timeDistribution.legendList' :gridWidth='true' :innerText="'单位：人次'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>各类型资源数量</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'citedByCoursesChart'"
                :datas="allTypeResource"
                :colorName="'2'"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>注册用户分类情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                  :refId="'typeChart'"
                  :datas="registerUser"
                  :colorName="'1'"
                />
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 第三层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程上传资源数排名（前10名）</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'uploadResourcesChart'" :datas='uploadResources.dataList' :transverseData='uploadResources.transverseData' :colorList='uploadResources.colorList' :gridY="'8%'"></tcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年标准化课程访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'standardCourseChart'" :datas='standardCourse.dataList' :transverseData='standardCourse.transverseData' :colorList='standardCourse.colorList' :legendList='standardCourse.legendList' :gridWidth='true' :innerText="'单位：人次'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第四层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年个性化课程访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'personalizedCourseChart'" :datas='personalizedCourse.dataList' :transverseData='personalizedCourse.transverseData' :colorList='personalizedCourse.colorList' :legendList='personalizedCourse.legendList' :gridWidth='true' :innerText="'单位：人次'"></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>开课期数少于2期的课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits1.tableList' :headerData='resourceVisits1.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits1.tableList.length >= 6" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits1.url,52,'开课期数少于2期的课程',resourceVisits1.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第五层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom:10px;">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>标准化课程学习人数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits2.tableList' :headerData='resourceVisits2.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits2.tableList.length >= 10" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits2.url,null,'标准化课程学习人数排名(前100名)',resourceVisits2.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>标准化课程访问量排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits3.tableList' :headerData='resourceVisits3.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits3.tableList.length >= 10" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits3.url,null,'标准化课程访问量排名(前100名)',resourceVisits3.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第六层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom:0px;">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>个性化课程访问量排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits4.tableList' :headerData='resourceVisits4.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits4.tableList.length >= 10" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits4.url,null,'个性化课程访问量排名(前100名)',resourceVisits4.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>标准化课程开课期数不少于2期的课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits5.tableList' :headerData='resourceVisits5.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits5.tableList.length >= 10" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits5.url,null,'标准化课程开课期数少于2期的课程(前100名)',resourceVisits5.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog :title="detailsBox.title" :visible.sync="detailsBox.show" :close-on-click-modal="false" width="600px" class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="moreBox">
        <tableList :tableData='detailsBox.data.tableList' :headerData='detailsBox.data.headerList'></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>


<script>
import circularChart from '@/components/chart/circularChart.vue' //引入圆形图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'    //横着的柱状图
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue' //引入竖柱状图图表
import discountChart from '@/components/chart/discountChart.vue' //引入折现图图表
import radarChart from '@/components/chart/radarChart.vue' //引入雷达图表
import meterChart from '@/components/chart/meterChart.vue' //仪表图
import tableList from '@/components/tableList.vue' //表格



export default {
  components: {
    circularChart,
    tcolumnarChart,
    vcolumnarChart,
    discountChart,
    radarChart,
    meterChart,
    tableList,
  },
  data() {
    return {
      colorList: ['#1BF6F8', '#3B86FF', '#FA4798', '#6FE05F', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],  //柱状图或折线图的颜色
      dashboardColor: [['#E67070', '#E10303'], ['#ECB853', '#DF9C0D'], ['#43CCB3', '#12A888']],    //仪表盘颜色红，黄，绿
      // 第一层
      courses: {  //课程类型分布
        dataList: [],
      },
      // natureDistribution: {  //课程性质分布
      //   dataList: [],
      // },
      resourcesCited: {  //课程引用资源数排名（前10名）
        dataList: [],
        transverseData: [],
        colorList: [],
      },


      // 第二层
      courseUtilization: {  //课程使用率
        dataList: 0,
        colorList: []
      },
      timeDistribution: {  //课程访问时间段分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },

      allTypeResource:[],// 各类型资源数量
      registerUser:[],//注册用户分类情况

      // 第三层
      uploadResources: {   // 课程上传资源数排名（前10名）
        dataList: [],
        transverseData: [],
        colorList: []
      },
      standardCourse: {   //近一年标准化课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },


      // 第四层
      personalizedCourse: {   //近一年个性化课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourceVisits1: {    //开课期数少于2期的课程
        tableList: [],
        headerList: [],
        url: ''
      },


      // 第五层
      resourceVisits2: {    //标准化课程学习人数排名
        tableList: [],
        headerList: [],
        url: ''
      },
      resourceVisits3: {   //标准化课程访问量排名
        tableList: [],
        headerList: [],
        url: ''
      },


      // 第六层
      resourceVisits4: {   //个性化课程访问量排名
        tableList: [],
        headerList: [],
        url: ''
      },
      resourceVisits5: {   //标准化课程开课期数少于2期的课程
        tableList: [],
        headerList: [],
        url: ''
      },

      // 弹窗
      detailsBox: {
        title: '',
        show: false,
        data: {
          tableList: [],
          headerList: []
        }
      }
    }
  },
  created() {
    this.resourceVisits1.url = this.$apiurls.overallPortrait_getResourceVisitCountRankByType
    this.resourceVisits2.url = this.$apiurls.curriculumPortrait_getCourseStandardStudyRank
    this.resourceVisits3.url = this.$apiurls.curriculumPortrait_getCourseStandardVisitRank
    this.resourceVisits4.url = this.$apiurls.curriculumPortrait_getCoursePersonalVisitRank
    this.resourceVisits5.url = this.$apiurls.curriculumPortrait_getCoursePeriodsRank

    // 第一层
    this.coursesDom()
    // this.natureDistributionDom()
    this.resourcesCitedDom()


    // 第二层
    this.courseUtilizationDom()
    this.timeDistributionDom()

    this.getResourceKindsStatisticsByTypeForPieEchart()

    this.getCourseSelection()

    // 第三层
    this.uploadResourcesDom()
    this.standardCourseDom()


    // 第四层
    this.personalizedCourseDom()
    this.resourceVisits1Dom()


    // 第五层
    this.resourceVisits2Dom()
    this.resourceVisits3Dom()

    // 第六层
    this.resourceVisits4Dom()
    this.resourceVisits5Dom()
  },
  methods: {
    // 第一层
    // 课程类型分布
    coursesDom() {
      this.$axios.post(this.$apiurls.overallPortrait_getCourseCount, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.courses.dataList = res.data
        }
      });
    },
    // // 课程性质分布
    // natureDistributionDom() {
    //   this.$axios.post(this.$apiurls.curriculumPortrait_variousResources, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       console.log("sasasas", res);
    //   this.natureDistribution.dataList = [{
    //     name: '数据1',
    //     value: 50
    //   }, {
    //     name: '数据2',
    //     value: 500
    //   }, {
    //     name: '数据3',
    //     value: 80
    //   }]
    //     }
    //   });
    // },
    //课程引用资源数排名（前10名）
    resourcesCitedDom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseRefResourceRank, 10, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourcesCited.dataList = res.data.value
          this.resourcesCited.transverseData = res.data.name
          this.resourcesCited.colorList = this.colorList
        }
      });
    },



    // 第二层
    // 课程使用率
    courseUtilizationDom() {
      this.$axios.post(this.$apiurls.overallPortrait_getCourseUtilization, {
        loading: false,
      }).then((res) => {
        if (res) {
          var value = res.data
          this.courseUtilization.dataList = value
          if (value >= 90) {
            this.courseUtilization.colorList = this.dashboardColor[2]
          } else {
            this.courseUtilization.colorList = this.dashboardColor[0]
          }
        }
      });
    },
    // 课程访问时间段分布
    timeDistributionDom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseActionTimeDistributionEchart, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          for (let i = 0; i < res.data.length; i++) {
            arrList.push(res.data[i].value)
          }
          this.timeDistribution.dataList = arrList
          this.timeDistribution.transverseData = res.data[0].name
          this.timeDistribution.colorList = this.colorList
          this.timeDistribution.legendList = ['标准化课程', '个性化课程']
        }
      });
    },



    // 各类型资源数量
    getResourceKindsStatisticsByTypeForPieEchart(){
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceKindsStatisticsByTypeForPieEchart,34, {
          loading: false,
        })
        .then((res) => {
          if (res.code===200) {
            this.allTypeResource=res.data
          }
        });
    },

    // 注册用户分类情况
    getCourseSelection(){
      this.$axios
        .post(this.$apiurls.getCourseSelection, {
          loading: false,
        })
        .then((res) => {
          if (res.code===200) {
            let data=res.data
            this.registerUser=[
              {
                name:"学生",
                value:data.student
              },
              {
                name:"教师",
                value:data.teacher
              },
              {
                name:"社会学习者",
                value:data.social
              },
              {
                name:"企业用户",
                value:data.enterprise
              },
              {
                name:"其他",
                value:data.other
              },
            ]
            // this.allTypeResource=res.data
          }
        });
    },

    // 第三层
    // 课程上传资源数排名（前10名）
    uploadResourcesDom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseUploadResourceRank, 10, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.uploadResources.dataList = res.data.value
          this.uploadResources.transverseData = res.data.name
          this.uploadResources.colorList = this.colorList
        }
      });
    },
    // 近一年标准化课程访问情况
    standardCourseDom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseMonthlyActionCountEchart, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.standardCourse.transverseData = res.data[0].name
          this.standardCourse.dataList = res.data[0].value
          this.standardCourse.colorList = this.colorList
          this.standardCourse.legendList = []
        }
      });
    },




    // 第四层
    // 近一年个性化课程访问情况
    personalizedCourseDom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseMonthlyActionCountEchart, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.personalizedCourse.transverseData = res.data[1].name
          this.personalizedCourse.dataList = res.data[1].value
          this.personalizedCourse.colorList = this.colorList
          this.personalizedCourse.legendList = []
        }
      });
    },
    // 开课期数少于2期的课程
    resourceVisits1Dom() {
      this.$axios.post(this.$apiurls.overallPortrait_getResourceVisitCountRankByType, {
        limitNum: '7',
        statType: 52
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 7) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits1.tableList = res.data
          this.resourceVisits1.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '创建者',
            prop: 'author'
          }, {
            name: '创建时间',
            prop: 'createTime'
          }]
        }
      });
    },



    // 第五层
    // 标准化课程学习人数排名
    resourceVisits2Dom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseStandardStudyRank, 11, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 11) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits2.tableList = res.data
          this.resourceVisits2.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '课程负责人',
            prop: 'author'
          }, {
            name: '学习人数',
            prop: 'num'
          }]
        }
      });
    },
    // 标准化课程访问量排名
    resourceVisits3Dom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseStandardVisitRank, 11, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 11) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits3.tableList = res.data
          this.resourceVisits3.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '课程负责人',
            prop: 'author'
          }, {
            name: '访问量',
            prop: 'num'
          }]
        }
      });
    },


    // 第六层
    // 个性化课程访问量排名
    resourceVisits4Dom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCoursePersonalVisitRank, 11, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 11) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits4.tableList = res.data
          this.resourceVisits4.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '课程负责人',
            prop: 'author'
          }, {
            name: '访问量',
            prop: 'num'
          }]
        }
      });
    },
    // 标准化课程开课期数少于2期的课程
    resourceVisits5Dom() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCoursePeriodsRank, 11, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 11) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits5.tableList = res.data
          this.resourceVisits5.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程类型',
            prop: 'courseType'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '课程负责人',
            prop: 'author'
          }, {
            name: '开课期数',
            prop: 'num'
          }]
        }
      });
    },
    // 查看更多
    seeMore(url, statType, title, headerList) {
      this.$store.commit('isLoading', true);
      this.detailsBox.data.tableList = []
      this.$axios.post(url, !statType ? 100 : {
        limitNum: 100,
        statType: statType
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.$message({
            message: '查询成功！',
            type: 'success'
          });
          this.detailsBox.data.tableList = res.data
          this.detailsBox.data.headerList = headerList
          this.detailsBox.show = true
          this.detailsBox.title = title
          this.$store.commit('modifyVague', true);
          this.$store.commit('isLoading', false);
        }
      }).catch(() => {
        this.$store.commit('isLoading', false);
      });
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false
      this.$store.commit('modifyVague', false);
    },
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/table.scss" scoped></style>
<style  lang="scss" scoped>
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
}

// .sameLayer:last-child {
//   padding-bottom: 40px;
// }

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
</style>
